/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { task } from 'ember-concurrency';
import FormValidations from 'cio/utils/form-validations';

import ArrayProxy from '@ember/array/proxy';
import CategoryModel from 'cio/models/category';
import SavedRowModel from 'cio/models/saved-row';
import { tracked } from '@glimmer/tracking';

export interface SavedRowProxy {
  name: string;
  category?: CategoryModel;
}

interface SavedRowsEditFormArgs {
  savedRow: SavedRowModel;
  categories?: ArrayProxy<CategoryModel>;
  disabled: boolean;
  onCancelEdit: () => unknown;
  onConfirmEdit: (rowProxy: SavedRowProxy) => unknown;
}

const Validations = {
  name(value: string) {
    if (isEmpty(value) || isEmpty(value.trim())) {
      return "Name can't be blank";
    }

    return true;
  },
};

export default class SavedRowsEditForm extends Component<SavedRowsEditFormArgs> {
  validations!: FormValidations;
  @tracked savedRowProxy!: SavedRowProxy;

  @computed('args.savedRow.{name,category}', 'args.disabled', 'savedRowProxy.{name,category}', 'saveTask.isRunning')
  get saveDisabled() {
    let nameUnchanged = this.args.savedRow.name === this.savedRowProxy.name;
    let categoryUnchanged = this.args.savedRow.category === this.savedRowProxy.category;
    return (
      (nameUnchanged && categoryUnchanged) ||
      this.args.disabled ||
      this.validations.hasErrors ||
      this.saveTask.isRunning
    );
  }

  constructor(owner: unknown, args: SavedRowsEditFormArgs) {
    super(owner, args);

    this.savedRowProxy = { name: args.savedRow.name, category: args.savedRow.category };

    this.validations = FormValidations.create({
      validations: Validations,
      context: this,
      modelKey: 'savedRowProxy',
    });
  }

  @action
  onNameChange(name: string) {
    this.savedRowProxy = {
      ...this.savedRowProxy,
      name,
    };
  }

  saveTask = task(async (e: Event) => {
    e.preventDefault();

    try {
      await this.validations.validateModel();
      this.args.onConfirmEdit(this.savedRowProxy);
    } catch {
      // handled by validations
    }
  });
}
